import { useState, useEffect, useCallback } from "react";
import { IconContext } from "react-icons";
import "./css/StartIMGSlider.css";

const StartIMGSlider = ({ slides }) => {
  const [sliderIDX, setSliderIDX] = useState(0);

  const prevSlide = useCallback(() => {
    setSliderIDX((prev) =>
      prev === 0 ? slides.length - 1 : prev - 1
    );
  }, [slides.length]);

  const nextSlide = useCallback(() => {
    setSliderIDX((prev) =>
      prev === slides.length - 1 ? 0 : prev + 1
    );
  }, [slides.length]);

  useEffect(() => {
    const slideInterval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => {
      clearInterval(slideInterval);
    };
  }, [nextSlide]);

  return (
    <IconContext.Provider value={{ className: "shared-class", size: 32 }}>
      <div className="startIMGSlider">
        <div className="imgHolder">
          <img src={slides[sliderIDX].url} alt="startIMG" />
        </div>
        <h1>{slides[sliderIDX].text}</h1>
      </div>
    </IconContext.Provider>
  );
};

export default StartIMGSlider;
